import { BsImage, BsPersonSquare } from 'react-icons/bs';

const WIDGET_ICONS = {
  looks: BsImage,
  newest_looks: BsImage,
  top_looks: BsImage,
  retailers: BsPersonSquare,
  newest_retailers: BsPersonSquare,
  top_retailers: BsPersonSquare,
};

export default WIDGET_ICONS;
